import { render, staticRenderFns } from "./organTree.vue?vue&type=template&id=08551cdd&scoped=true&"
import script from "./organTree.vue?vue&type=script&lang=js&"
export * from "./organTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08551cdd",
  null
  
)

export default component.exports